import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=667bd1e3&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
import style0 from "./Clients.vue?vue&type=style&index=0&id=667bd1e3&prod&scoped=true&lang=css"
import style1 from "./Clients.vue?vue&type=style&index=1&id=667bd1e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667bd1e3",
  null
  
)

export default component.exports